import UserEditingFormContainer from './UserEditingFormContainer';

export default UserEditingFormContainer;
